import isNil from 'lodash/isNil';
import omitBy from 'lodash/omitBy';

/** 净化对象，去除值为 undefined、null 或空字符串的属性 */
export function cleanObject<T extends object>(o: T): Partial<T> {
  if (typeof o !== 'object' || o === null || Array.isArray(o)) {
    return {};
  }
  return omitBy(o, (value) => isNil(value) || value === '');
}

// 用法示例
// const o = { name: '', page: 1, desc: undefined, type: null };
// const cleaned = cleanObject(o); // { page: 1 }
